// extracted by mini-css-extract-plugin
export default {"me":"contact_me__-00Vp","autoRotate":"contact_autoRotate__u+yXy","center_wrapper":"contact_center_wrapper__ba4QQ","icon_group":"contact_icon_group__fV+Ih"};